/* eslint-disable @typescript-eslint/no-var-requires */
import { AwsCognitoOAuthOpts } from '@aws-amplify/auth/lib-esm/types';
import { Auth } from '@aws-amplify/auth';
import { Amplify } from '@aws-amplify/core';

const AWSConfig = {
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'ap-southeast-2',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'ap-southeast-2_oRHX9GBEK',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: '1pko4kjgrn0c9m7ct6ns8l1gtc',

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: 'USER_SRP_AUTH',

    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: 'carboncrop.auth.ap-southeast-2.amazoncognito.com',
      // URLs for social identity provider
      redirectSignIn: `${window.location.origin}/login`,
      redirectSignOut: `${window.location.origin}/login`,
      // 'code' or 'token', note that REFRESH token will only be generated when the responseType is code
      responseType: 'code',
    },
  },
};

Amplify.configure(AWSConfig);

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/),
);

const rawAwsconfig = Auth.configure(AWSConfig);

// Assuming you have two redirect URIs, and the first is for localhost and second is for production
const [localSignIn, productionSignIn] = (
  rawAwsconfig.oauth as AwsCognitoOAuthOpts
).redirectSignIn.split(',');
const [localSignOut, productionSignOut] = (
  rawAwsconfig.oauth as AwsCognitoOAuthOpts
).redirectSignOut.split(',');

// Local & product URLs for Cognito sign up/in
const awsconfig = {
  ...rawAwsconfig.oauth,
  redirectSignIn: isLocalhost ? localSignIn : productionSignIn,
  redirectSignOut: isLocalhost ? localSignOut : productionSignOut,
};

Amplify.configure(awsconfig);
